import React, { FC, useMemo } from 'react';
import { Section } from 'omni-package-react-core';
import { useTranslation } from 'react-i18next';
import { PersonalInformation } from '../../interfaces/PersonalInformation';
import { StyledLine } from './Address.styles';
import isAddressEmpty from './isAddressEmpty';

export interface AddressProps {
  personalInfo: PersonalInformation;
  isEditingAddress?: boolean;
}
const Address: FC<AddressProps> = ({ personalInfo, isEditingAddress }) => {
  const { t } = useTranslation('Address');
  const infos = useMemo(() => ({ ...personalInfo?.address }), [personalInfo]);

  if (!personalInfo || !personalInfo.address) return null;
  if (personalInfo?.address.behaviours.showSection === false) return null;
  if (isAddressEmpty(infos)) return null;
  return (
    <Section name={t(isEditingAddress ? 'currentAddressTitle' : 'addressTitle')}>
      <StyledLine>
        {infos.appartementOrSuite && `${infos.appartementOrSuite}-`}
        {infos.civicNumber}{((infos.civicNumber && infos.street) && ', ')}{infos.street}
        {infos.deliveryMethod && ` ${t(infos.deliveryMethod)}`}
        {infos.postOfficeBox && ` ${infos.postOfficeBox}`}
        {infos.externalPlace && ` ${infos.externalPlace}`}
      </StyledLine>
      <StyledLine>
        {infos.city} {infos.province} {infos.postalCode}
      </StyledLine>
      <StyledLine>
        {infos.country}
      </StyledLine>
    </Section>
  );
};
export default Address;
